import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CiPlay1 } from "react-icons/ci";
import { CiStop1 } from "react-icons/ci";
const PlayButton = ({ audioEnv, playStatus, setPlayStatus }) => {
    const id = useSelector((state) => state.filters.questionId)
    const handlePlay = () => {
        setPlayStatus(!playStatus);
    };

    useEffect(() => {
        const env = audioEnv;
        if (env) playStatus ? env.play() : env.pause();
    }, [playStatus, audioEnv]);


    useEffect(() => {
        const env = audioEnv;
        if (env) env.pause();
    }, [id, audioEnv]);

    return (
        <div className="play-button-container container">
            <button className={`play-button button ${playStatus ? 'Pause' : 'Play'}`} onClick={handlePlay}>
                <span>{playStatus ? <CiStop1/> : <CiPlay1/>}</span>
            </button>
        </div>
    )
}

export default PlayButton